
import { useCameraStore } from "../stores/cameraStore";

/** Camera hook — bridges camera state for view mode controls */
export function useCamera() {
  const viewPreset = useCameraStore((s) => s.viewPreset);
  const isAnimating = useCameraStore((s) => s.isAnimating);
  const cinematicActive = useCameraStore((s) => s.cinematicActive);
  const cinematicStyle = useCameraStore((s) => s.cinematicStyle);
  const centerTarget = useCameraStore((s) => s.centerTarget);
  const homeRequest = useCameraStore((s) => s.homeRequest);
  const setViewPreset = useCameraStore((s) => s.setViewPreset);
  const setCinematicStyle = useCameraStore((s) => s.setCinematicStyle);
  const resetCamera = useCameraStore((s) => s.resetCamera);
  const requestHome = useCameraStore((s) => s.requestHome);
  const cancelAnimation = useCameraStore((s) => s.cancelAnimation);
  const setAnimating = useCameraStore((s) => s.setAnimating);
  const setCinematicActive = useCameraStore((s) => s.setCinematicActive);
  const centerOnObject = useCameraStore((s) => s.centerOnObject);
  const clearCenterTarget = useCameraStore((s) => s.clearCenterTarget);

  return {
    viewPreset,
    isAnimating,
    cinematicActive,
    cinematicStyle,
    centerTarget,
    homeRequest,
    setViewPreset,
    setCinematicStyle,
    resetCamera,
    requestHome,
    cancelAnimation,
    setAnimating,
    setCinematicActive,
    centerOnObject,
    clearCenterTarget,
  };
}
